module.exports = {
    "MM/DD/YYYY": "[Le] DD/MM/YYYY",
    'You must be an <span>XXL</span> member': 'Vous devez être membre <span>XXL</span>',
    'to open this photo.': 'pour ouvrir cette photo.',
    'Become an XXL member': 'Devenez membre XXL',

    'Log in': 'Connectez-vous'
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/member_photo.js